module.exports = __webpack_public_path__ + "static/telecommute-chat-card-b4ca4274719a41eab468c5ab830679e6.png";